<template>
	<div>
		<div class="integral pad my-point-2021">
			<p class="explain_record">
				<img src="/static/line.png" alt="">
				<span>寄存库存</span>
			</p>
		</div>
		<ul class="record_list">
			<li v-for="(item,index) in list" :key="index"><img :src="'/userfile/default/picture/' + item.productID_simage" /><span>{{item.productID_sname}}</span><h3>{{item.num}}{{item.unit}}</h3></li>
		</ul>
		<div class="no-data" v-if="list.length == 0"></div>
	</div>
</template>

<script>
import {
  OrderInOutStock
} from "@/api/api.js"
export default {
  data () {
    return {
		list:[]
    }
  },
  methods:{
  },
  created:function(){
	  let that = this;
	  OrderInOutStock({},function(res){
		  that.list = res.data;
	  })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/stock.vue